module.exports = __webpack_public_path__ + "static/img/South-Paris-Arena.ed75075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/South-Paris-Arena.jpg
// module id = mF3v
// module chunks = 0